export const PHONE_MASK = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
export const PHONE_REGEXP = /^\d{3}-\d{3}-\d{4}$/;
